import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import TableAddedProductsCode from '@/presentation/components/custom-products/table-added-products/table-added-products.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new TableAddedProductsCode();

		return {
			isLoading: code.isLoading,
			idsOfModifiedCustomProducts: code.idsOfModifiedCustomProducts,
			selectedTableActionsDropdown: code.selectedTableActionsDropdown,
			customProducts: code.customProducts,
			retrieveDateStringForCustomProduct: code.retrieveDateStringForCustomProduct.bind(code),
			retrievePriceForCustomProduct: code.retrievePriceForCustomProduct.bind(code),
			retrieveTypeForCustomProduct: code.retrieveTypeForCustomProduct.bind(code),
			onDropdownTriggerClicked: code.onDropdownTriggerClicked.bind(code),
			onEditClicked: code.onEditClicked.bind(code),
			onDuplicateClicked: code.onDuplicateClicked.bind(code),
			onDeleteClicked: code.onDeleteClicked.bind(code)
		};
	}
});
